import ReactGA from 'react-ga4'

import config, { isLocalDev } from 'config'

ReactGA.initialize(config.gaKey, { testMode: isLocalDev })

export function gtag(...args) {
  if (isLocalDev) {
    console.log('GTAG', ...args)
  }
  ReactGA.gtag(...args)
}

export function logEvent(name) {
  gtag('event', name)
}

export default logEvent
